import DatePicker from "../General/DatePicker";
import DropdownValueHandler from "../shared/SuperSearch/DropdownValueHandler"
import SuperSearchList from "../shared/SuperSearch/SuperSearchList"

const AddNewBlockAppointment = (props) => {
    const { locationList, providersList, mainBlockAppointmentModal, handleOnChangeBlock, handleCalendarChange, blockAppointmentValidation, handleOnBlockClose, handleAppointment,
        IsEditAllowed, BlockAvailableStartTimeSlots, BlockAvailableEndTimeSlots, ReasonDD, handleBlockSelectedData } = props;
    return (
        <>
            <div className='px-3'>
                <div className='d-flex flex-wrap row-gap-8 mt-2'>
                    <div className="col-md-5 pe-2">
                        <div className={'input ar-multiple-br'}>
                            <label>Location<span style={{ color: 'red' }}>*</span></label>
                            <div className={blockAppointmentValidation.LocationID ? 'input error' : 'input'}>
                                <SuperSearchList
                                    type="client"
                                    id='LocationID'
                                    name='LocationID'
                                    searchValue={mainBlockAppointmentModal.LocationID}
                                    data={locationList}
                                    onChange={(e) => handleOnChangeBlock(e)}
                                    getSelectedData={handleBlockSelectedData}
                                    // is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    className="form-control rounded"
                                    inputError={blockAppointmentValidation.LocationID}
                                />
                                {blockAppointmentValidation.LocationID}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className={'input ar-multiple-br'}>
                            <label>Provider<span style={{ color: 'red' }}>*</span></label>
                            <div className={blockAppointmentValidation.ProviderID ? 'input error' : 'input'}>
                                <SuperSearchList
                                    type="client"
                                    id='ProviderID'
                                    name='ProviderID'
                                    searchValue={mainBlockAppointmentModal.ProviderID}
                                    data={providersList}
                                    onChange={(e) => handleOnChangeBlock(e)}
                                    getSelectedData={handleBlockSelectedData}
                                    // is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    className="form-control rounded"
                                    inputError={blockAppointmentValidation.ProviderID}
                                />
                                {blockAppointmentValidation.ProviderID}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 pe-2">
                        <DatePicker
                            label='Start Date'
                            value={mainBlockAppointmentModal.AppointmentDate}
                            handleCalendarChangefunc={date => handleCalendarChange(date, "block")}
                        />
                    </div>
                    <div className={`col-md-5 pe-2 ${mainBlockAppointmentModal?.AllDay ? 'disable' : ''}`}>
                        <div className={'input ar-multiple-br'}>
                            <label>Start Time{!mainBlockAppointmentModal?.AllDay && <span style={{ color: 'red' }}>*</span>}</label>
                            <div className={blockAppointmentValidation.StartTime ? 'input error' : 'input'}>
                                {!mainBlockAppointmentModal?.AllDay && BlockAvailableStartTimeSlots?.length > 0
                                    ?
                                    <SuperSearchList
                                        type="client"
                                        id='AppointmentStart'
                                        name='AppointmentStart'
                                        searchValue={mainBlockAppointmentModal.AppointmentStart}
                                        data={BlockAvailableStartTimeSlots}
                                        onChange={(e) => handleOnChangeBlock(e)}
                                        getSelectedData={handleBlockSelectedData}
                                        // is={is}
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        className="form-control rounded"
                                        inputError={blockAppointmentValidation?.StartTime}
                                    />
                                    :
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={mainBlockAppointmentModal?.AllDay && BlockAvailableStartTimeSlots?.length > 0 ? "" : "No Slot Available"}
                                        value={""}
                                        readOnly
                                    />
                                }
                                {blockAppointmentValidation?.StartTime}
                            </div>
                        </div>
                    </div>
                    <div className={`col-md-5 pe-2 ${mainBlockAppointmentModal?.AllDay ? 'disable' : ''}`}>
                        <div className={`input ar-multiple-br`}>
                            <label>End Time{!mainBlockAppointmentModal?.AllDay && <span style={{ color: 'red' }}>*</span>}</label>
                            <div className={blockAppointmentValidation.EndTime ? 'input error' : 'input'}>
                                {/* <select className="form-control fc-xs" id="AppointmentEnd" name="AppointmentEnd" onChange={handleOnChangeBlock} value={mainBlockAppointmentModal.AppointmentEnd}>
                                                                   {availableEndTimeSlots.length != 0 && <option value=""></option>}
                                                                   {(
                                                                       availableEndTimeSlots.length != 0 ? availableEndTimeSlots.map((slot) => {
                                                                           return (
                                                                               <> */}
                                {/* <option value=""></option>
                                                                                    */}
                                {/* <option value={slot.value}>{slot.display}</option>
                                                                               </>)
   
                                                                       }) : (<option value="">No Slot Available</option>))}
                                                               </select> */}
                                {!mainBlockAppointmentModal?.AllDay && BlockAvailableEndTimeSlots?.length > 0
                                    ?
                                    <SuperSearchList
                                        type="client"
                                        id='AppointmentEnd'
                                        name='AppointmentEnd'
                                        searchValue={mainBlockAppointmentModal.AppointmentEnd}
                                        data={BlockAvailableEndTimeSlots}
                                        onChange={(e) => handleOnChangeBlock(e)}
                                        getSelectedData={handleBlockSelectedData}
                                        // is={is}
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        className="form-control rounded"
                                        inputError={blockAppointmentValidation?.EndTime}
                                    />
                                    :
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={mainBlockAppointmentModal?.AllDay && BlockAvailableEndTimeSlots?.length > 0 ? "" : "No Slot Available"}
                                        value={""}
                                        readOnly
                                    />
                                }
                                {blockAppointmentValidation?.EndTime}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 d-flex align-items-end ps-2">
                        <div className="d-flex align-items-center custom_check_box">
                            <input type="checkbox" className='form-check-input p-0 mt-0' name="AllDay" id="AllDay" checked={mainBlockAppointmentModal?.AllDay} onChange={(e) => handleOnChangeBlock(e)} />
                            <label id="Daily" className="text ms-1 cursor-pointer">All Day</label>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className={'input ar-multiple-br'}>
                            <label>Reason<span style={{ color: 'red' }}>*</span></label>
                            <div className={blockAppointmentValidation.Reason ? 'input error' : 'input'}>
                                <SuperSearchList
                                    type="client"
                                    id='Reason'
                                    name='Reason'
                                    searchValue={mainBlockAppointmentModal.Reason}
                                    data={ReasonDD}
                                    onChange={(e) => handleOnChangeBlock(e)}
                                    getSelectedData={handleBlockSelectedData}
                                    // is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    className="form-control rounded"
                                    inputError={blockAppointmentValidation?.Reason ? true : false}
                                />
                                {blockAppointmentValidation?.Reason}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className='form-group input'>
                            <label htmlFor="Comments">Comments</label>
                            <textarea type="text"
                                rows={2}
                                className='form-control'
                                name="Notes"
                                value={mainBlockAppointmentModal.Notes}
                                id="Notes"
                                onChange={handleOnChangeBlock}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="tabs-action-bottom mt-2">
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => handleOnBlockClose()}>Cancel</button>
                    <button className={IsEditAllowed ? "btn btn-validate px-10 h-100" : "btn btn-validate px-10 h-100 disabled"} onClick={() => handleAppointment("block")}>Save</button>
                </div>
            </div>

        </>
    )
}

export default AddNewBlockAppointment